export const ParamContextProvide = {
  context: 'paramContext'
};
//# sourceMappingURL=const.js.map
